/** Nomenclature item available types */
export enum NomenclatureTypeEnum {
  /** Goods to sale or buy */
  PRODUCT = 'PRODUCT',
  /** Service to sale or buy */
  SERVICE = 'SERVICE'
}
